// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-templates-course-page-js": () => import("D:\\Projects\\gatsby-theme-courses\\gatsby-theme-courses\\src\\templates\\coursePage.js" /* webpackChunkName: "component---src-templates-course-page-js" */),
  "component---src-templates-lesson-page-js": () => import("D:\\Projects\\gatsby-theme-courses\\gatsby-theme-courses\\src\\templates\\lessonPage.js" /* webpackChunkName: "component---src-templates-lesson-page-js" */),
  "component---src-templates-courses-page-js": () => import("D:\\Projects\\gatsby-theme-courses\\gatsby-theme-courses\\src\\templates\\coursesPage.js" /* webpackChunkName: "component---src-templates-courses-page-js" */)
}

